export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export type BulletOwner = "player" | "invader";

export type InvaderKind = "top" | "mid" | "bottom";

export enum GameState {
  Ready = "ready",
  Playing = "playing",
  Win = "win",
  GameOver = "gameover",
}

/** Where and what kind an invader should be built as. */
export interface InvaderSeed {
  x: number;
  y: number;
  kind: InvaderKind;
}

/** A single bunker: its origin plus the block grid that gives it its shape. */
export interface BunkerSeed {
  x: number;
  y: number;
  shape: number[][];
  blockSize: number;
}

/** The parts of an input source the game reads. Controls and Autopilot both satisfy it. */
export interface ControlsLike {
  left: boolean;
  right: boolean;
  fire: boolean;
}

/** A read-only view of the board, for input sources that need to see it. */
export interface GameSnapshot {
  player: Rect;
  invaders: Rect[];
  invaderBullets: Rect[];
  canvasWidth: number;
}
